
const state = {
  tagSearchList: [],
  tagTabType: 'vod'
}

const getters = {
  tagSearchList () {
    return state.tagSearchList
  },
  tagTabType () {
    return state.tagTabType
  }
}
const mutations = {
  // VueWOrdCloud.vue에서 사용 확인 필요
  setTagSearchKeywordList (state, keywordList) {
    state.tagSearchKeywordList = keywordList
  },
  // VueWOrdCloud.vue에서 사용 확인 필요
  setTagSearchFilterIndex (state, index) {
    state.tagSearchFilterIndex = index
  },
  setTagSearchList (stats, tagList) {
    state.tagSearchList = tagList
  },
  deleteAllTag (state) {
    state.tagSearchList = []
  },
  setTagTabType (state, type) {
    state.tagTabType = type
  },
  deleteTag (state, tag) {
    state.tagSearchList = state.tagSearchList.filter((selectedTag) => {
      return tag.text !== selectedTag.text
    })
  }

}

export default { state, getters, mutations }
